import { render, staticRenderFns } from "./Bitrix24ConfigCard.vue?vue&type=template&id=711a676e&"
import script from "./Bitrix24ConfigCard.vue?vue&type=script&lang=ts&"
export * from "./Bitrix24ConfigCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports